"use client";

import { RotateCcwIcon } from "lucide-react";
import Link from "next/link";

import { Button } from "@/shared-web.ui/ui.button";

type ErrorDict = {
  title: string;
  message: string;
  code: string;
};
type ResetDict = {
  func: () => void;
  label?: string;
};

interface BaseErrorProps {
  error: ErrorDict;
  reset?: ResetDict;
}
const BaseError = (props: BaseErrorProps) => {
  const {
    error,
    reset,
  } = props;

  return (
    <div className={`
      flex h-dvh items-center justify-center bg-gray-1
    `}
    >
      <div className="max-w-screen-md p-6">
        <h1 className={`
          mb-4 text-8 text-gray-11
          sm:text-9
        `}
        >
          <span className="font-bold text-accent-11 pr-3">
            Oops!
          </span>
          {error.title}
        </h1>
        <p className="mb-6 text-gray-11">
          {error.message}
        </p>
        <p className="mb-4 text-gray-11">
          Error Code:
          <span className="pl-1 font-semibold">
            { error.code }
          </span>
        </p>
        <div className={`
          mt-10 flex flex-col items-start justify-start
          gap-8
          sm:flex-row sm:items-center
        `}
        >
          <Link href="/">
            <Button size="4">
              Go to Homepage
            </Button>
          </Link>
          {reset && (
            <Button
              onClick={reset.func}
              size="4"
              variant="outline"
            >
              <RotateCcwIcon
                strokeWidth="2"
                className="size-5"
              />
              {reset.label || "Try Again"}
            </Button>
          )}
        </div>
      </div>
    </div>
  ); ;
};

export {
  BaseError,
  type BaseErrorProps,
  type ErrorDict,
  type ResetDict,
};
